// extracted by mini-css-extract-plugin
module.exports = {"hero":"Home_hero__18ykk","wrap":"Home_wrap__Mt_Yl"};